import React from 'react';
import { useConfigContext } from 'contexts/configContext';

const Logo = () => {
  const { visualConfig } = useConfigContext();
  const logoUrl = visualConfig?.logoUrl;

  if (!logoUrl) return null;

  return <img src={logoUrl} alt="logo" />;
};

export default Logo;
